/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {useEffect, useState} from "react";
import {get} from "../core/request";
import timeout from "../utils/timeout";
import {token} from "../core/auth/token";
import {logout} from "../core/auth/authentication";
import {ReloadOutlined} from "@ant-design/icons";
import {Tooltip} from "antd";

export function Timer(props: any) {
    const [spin, setSpin] = useState(false)
    const [timer, setTimer] = useState("--:--");

    function tick() {
        if (token.exists()) {
            let remainig = token.remainingStr();
            setTimer(remainig ? remainig : "");
            if (token.isExpired()) {
                logout()
            }
        }
    }

    useEffect(() => {
        var interval = setInterval(() => tick(), 500);

        return function cleanup() {
            clearInterval(interval);
        };
    });

    return <Tooltip overlay='Timer zurücksetzen'>
        <div
            onClick={
                () => {
                    setSpin(true);
                    get("auth/renew")
                        .done(() => timeout(1000).then(() => setSpin(false)))  // spin 1 sec
                        .fail(() => setSpin(false) //stop immediately
                        )
                }
            }
        >
            <ReloadOutlined spin={spin}/>&nbsp;{timer}
        </div>
    </Tooltip>;
}